// extracted by mini-css-extract-plugin
module.exports = {"textareaStyle":"notes-module--textareaStyle--2ZWRS","align_btns":"notes-module--align_btns--1RKSq","more_option":"notes-module--more_option--1J9V3"};